/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Comparison } from './';
import {
    ComparisonFromJSON,
    ComparisonFromJSONTyped,
    ComparisonToJSON,
} from './';

/**
 * 
 * @export
 * @interface SyncComparison
 */
export interface SyncComparison {
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    legalNameComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    registrationNumberComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    vatNumberComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    formattedAddressComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    streetComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    street2Comparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    cityComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    zipCodeComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    countryCodeComparison?: Comparison;
    /**
     * 
     * @type {Comparison}
     * @memberof SyncComparison
     */
    hqRegistrationCityComparison?: Comparison;
}

/**
 * Check if a given object implements the SyncComparison interface.
 */
export function instanceOfSyncComparison(value: object): value is SyncComparison {
    return true;
}

export function SyncComparisonFromJSON(json: any): SyncComparison {
    return SyncComparisonFromJSONTyped(json, false);
}

export function SyncComparisonFromJSONTyped(json: any, ignoreDiscriminator: boolean): SyncComparison {
    if (json == null) {
        return json;
    }
    return {
        
        'legalNameComparison': json['legalNameComparison'] == null ? undefined : ComparisonFromJSON(json['legalNameComparison']),
        'registrationNumberComparison': json['registrationNumberComparison'] == null ? undefined : ComparisonFromJSON(json['registrationNumberComparison']),
        'vatNumberComparison': json['vatNumberComparison'] == null ? undefined : ComparisonFromJSON(json['vatNumberComparison']),
        'formattedAddressComparison': json['formattedAddressComparison'] == null ? undefined : ComparisonFromJSON(json['formattedAddressComparison']),
        'streetComparison': json['streetComparison'] == null ? undefined : ComparisonFromJSON(json['streetComparison']),
        'street2Comparison': json['street2Comparison'] == null ? undefined : ComparisonFromJSON(json['street2Comparison']),
        'cityComparison': json['cityComparison'] == null ? undefined : ComparisonFromJSON(json['cityComparison']),
        'zipCodeComparison': json['zipCodeComparison'] == null ? undefined : ComparisonFromJSON(json['zipCodeComparison']),
        'countryCodeComparison': json['countryCodeComparison'] == null ? undefined : ComparisonFromJSON(json['countryCodeComparison']),
        'hqRegistrationCityComparison': json['hqRegistrationCityComparison'] == null ? undefined : ComparisonFromJSON(json['hqRegistrationCityComparison']),
    };
}

export function SyncComparisonToJSON(value?: SyncComparison | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'legalNameComparison': ComparisonToJSON(value['legalNameComparison']),
        'registrationNumberComparison': ComparisonToJSON(value['registrationNumberComparison']),
        'vatNumberComparison': ComparisonToJSON(value['vatNumberComparison']),
        'formattedAddressComparison': ComparisonToJSON(value['formattedAddressComparison']),
        'streetComparison': ComparisonToJSON(value['streetComparison']),
        'street2Comparison': ComparisonToJSON(value['street2Comparison']),
        'cityComparison': ComparisonToJSON(value['cityComparison']),
        'zipCodeComparison': ComparisonToJSON(value['zipCodeComparison']),
        'countryCodeComparison': ComparisonToJSON(value['countryCodeComparison']),
        'hqRegistrationCityComparison': ComparisonToJSON(value['hqRegistrationCityComparison']),
    };
}

